import Pagination from "components/CustomWidgets/pagination";
import GridCards from "components/Explore/components/GridCards";
import ListCards from "components/Explore/components/ListCards";
import { ExploreContext } from "context/ExploreContext";
import useMediaQuery from "hooks/useMediaQuery";
import { useContext, useEffect, useState } from "react";
import { usePremium } from "context/PremiumContext";
import "../../../Engage/style.scss";
import { retrieveToken } from "utils/storage";
import GoPremiumModal from "components/CustomWidgets/goPremiumModal";

export function CardLists({
  isListing,
  data = [],
  setCurrent,
  current,
  count,
  activeTab,
  tabVariant,
  label,
  secondaryTabActive,
  selectedList,
}) {
  const { cardLayout, setCardLayout, isNotInterested } =
    useContext(ExploreContext);
  const isMobile = useMediaQuery("(max-width: 820px)");
  const { isPremium } = usePremium();
  const [upgrade, setUpgradeModal] = useState(() => {
    if (isPremium) return false;
    return retrieveToken("gopremiummodal") !== "true";
  });

  useEffect(() => {
    if (isPremium) return; // don't run if user is premium

    const interval = setInterval(
      () => {
        setUpgradeModal(true);
      },
      10 * 60 * 1000,
    ); // every 10 minutes

    return () => clearInterval(interval);
  }, [isPremium]);

  useEffect(() => {
    if (isMobile) {
      setCardLayout("grid");
    }
  }, [isMobile]);

  const transformedData = data?.map((item) => ({
    aec_id: item?.aec_id,
    id: item.id,
    profileImage: item.profile_image,
    imageCount: item.image_count,
    profileName: item.name,
    profileAge: item.age,
    profileHeight: item.height,
    profileOcc: item.profession,
    verificationType: item.verification_type,
    isShow: !item.allow_image_view,
    isLike: item.has_expressed_interest,
    isFav: item.has_favorited,
    isPremium: item.is_premium_member,
    isSuggest: false,
    profileId: item.aec_id,
    lastSeen: item.last_seen,
    religion: item.religion,
    maritalStatus: item.marital_status,
    livesIn: item.lives_in,
    primaryLanguage: item.primary_language,
    createdBy: item.created_by,
    image_request: item?.image_requested,
    isPrivate: item?.is_private,
    contactReqByMe: tabVariant === "5" && activeTab === "1",
    contactReqByOthers: tabVariant === "5" && activeTab === "2",
    photoReqByMe: tabVariant === "4" && activeTab === "1",
    photoReqByOthers:
      tabVariant === "4" && activeTab === "2" && secondaryTabActive === "5",
    interestReqByOthers: tabVariant === "2" && activeTab === "2",
  }));

  const firstHalf = transformedData.slice(0, 8);
  const secondHalf = transformedData.slice(8);

  return (
    <div className="flex flex-col gap-8">
      <div className="explore-tab-content gap-6 relative">
        {cardLayout === "grid" ? (
          <GridCards
            firstHalf={firstHalf}
            secondHalf={secondHalf}
            isNotInterested={isNotInterested}
            isListing={isListing}
            tabActive={tabVariant}
            activeTab={activeTab}
            cardClassName={
              isPremium &&
              String(activeTab) === "2" &&
              ["1", "2", "3"].includes(tabVariant)
                ? "blurred-card"
                : ""
            }
            isCardShow={
              data.length > 0 &&
              String(activeTab) === "2" &&
              ["1", "2", "3"].includes(tabVariant) &&
              !isPremium
            }
            secondaryTabActive={secondaryTabActive}
            selectedList={selectedList}
          />
        ) : (
          <ListCards
            firstHalf={firstHalf}
            secondHalf={secondHalf}
            isNotInterested={isNotInterested}
            isListing={isListing}
            tabActive={tabVariant}
            cardClassName={
              !isPremium &&
              String(activeTab) === "2" &&
              ["1", "2", "3"].includes(tabVariant)
                ? "blurred-card"
                : ""
            }
            isCardShow={
              data.length > 0 &&
              String(activeTab) === "2" &&
              ["1", "2", "3"].includes(tabVariant) &&
              !isPremium
            }
            secondaryTabActive={secondaryTabActive}
            selectedList={selectedList}
            activeTab={activeTab}
          />
        )}
      </div>

      <Pagination
        total={count?.count}
        currentPageNo={current}
        onChange={(page) => setCurrent(page)}
        pageSize={count?.limit}
      />

      {upgrade && tabVariant === "3" && label === "Who favorited me?" && (
        <GoPremiumModal
          key="go-premium"
          open={upgrade}
          wrapClassName={`go-premium-primary`}
          contentTitle={"To unlock more features"}
          buttonTitle={"Go premium now"}
          onCancel={() => setUpgradeModal(false)}
          onOk={() => setUpgradeModal(false)}
          title="Congratulations, you are now registered."
          description="Now, let's complete your profile."
        />
      )}
    </div>
  );
}
